var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelekomLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 396.9 396.9",
    style: {
      enableBackground: "new 0 0 396.9 396.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E20074;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hintergrund"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 396.9,
    height: 396.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Telekom_Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,243.8H79.4v-56.7h28.3h28.3V243.8z M79.4,56.7v96.4h17v-2.8c0-45.4,25.5-73.7,73.7-73.7h2.8v204.1 c0,28.3-11.3,39.7-39.7,39.7h-8.5v19.8h147.4v-19.8h-8.5c-28.3,0-39.7-11.3-39.7-39.7V76.5h2.8c48.2,0,73.7,28.3,73.7,73.7v2.8h17 V56.7H79.4z M260.8,243.8h56.7v-56.7h-28.3h-28.3V243.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelekomLogo);
export default __webpack_public_path__ + "static/media/telekom-logo.8586abbf121cdc19bdfc74606820f65c.svg";
export { ForwardRef as ReactComponent };